import {
  UPLOAD_SINGLE_PHOTO_INIT,
  UPLOAD_SINGLE_PHOTO_SUCCESS,
  UPLOAD_SINGLE_PHOTO_FAILURE,
} from '@store/action-types/single-upload';
import client from '@api-sdk/client';
import { enqueueSnackbar } from '@store/actions/toast';
import translateToastMessage from '@shared/utils/translateToastMessage';

const uploadSinglePhotoInit = () => ({ type: UPLOAD_SINGLE_PHOTO_INIT });
const uploadSinglePhotoSuccess = photo => ({ type: UPLOAD_SINGLE_PHOTO_SUCCESS, payload: { photo } });
const uploadSinglePhotoFailure = error => ({ type: UPLOAD_SINGLE_PHOTO_FAILURE, payload: { error } });

const uploadSinglePhoto = ({ base64, fileName }) => async dispatch => {
  dispatch(uploadSinglePhotoInit());

  try {
    const uploadPhotoResponse = await client.uploadSinglePhoto({
      data: { file: { base64, fileName } },
    });

    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('upload.singlePhoto'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'success',
        },
      }),
    );
    return dispatch(uploadSinglePhotoSuccess(uploadPhotoResponse.response));
  } catch (error) {
    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('upload.error.singlePhoto'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'error',
        },
      }),
    );
    return dispatch(uploadSinglePhotoFailure(error));
  }
};

export default uploadSinglePhoto;
